import { withErrorBoundary } from "@sentry/react";
import {
  ArtifactType,
  MeetingViewMeetingNodeNewPageFragmentFragment,
} from "types/graphql-schema";

import useLabel from "@apps/use-label/use-label";
import Error from "@components/error/error";

import MeetingSidebarSection from "./meeting-sidebar-collapsible-container";
import MeetingRecognitionCollapsible from "./recognition-collapsible";
import useMeetingSidebarSection from "./use-meeting-sidebar-collapsible-container";

const Recognitions = ({
  meeting,
}: {
  meeting: MeetingViewMeetingNodeNewPageFragmentFragment;
}) => {
  const label = useLabel();
  const {
    isFormalOneonone,
    subject,
    filterAssigneeId,
    participantIds,
    toggledAssignee,
    toggledJustMeeting,
  } = useMeetingSidebarSection({
    meeting,
    collapsibleFilterName: "Recognitions",
  });

  const commonFilters = {
    meetingGroupId: toggledJustMeeting ? meeting.meetingGroup?.id : undefined,
    first: 5,
  };

  return (
    <MeetingSidebarSection
      expandedUiPreferenceKey="meetingSidebarRecognitionsContainerExpanded"
      collapsibleFilterName="Recognitions"
      subject={subject}
      isFormalOneonone={isFormalOneonone}
      toggledAssignee={toggledAssignee}
      toggledJustMeeting={toggledJustMeeting}
      createArtifactFormOptions={{
        artifactType: ArtifactType.Recognition,
        meetingId: meeting.id,
        meetingGroupId: meeting.meetingGroup?.id,
      }}
      titleLabel="recognition"
    >
      <MeetingRecognitionCollapsible
        expandedUiPreferenceKey="meetingReceivedRecognitionsExpanded"
        meeting={meeting}
        title={`${label("recognition", {
          pluralize: true,
          capitalize: true,
        })} received`}
        variables={{
          ...commonFilters,
          fetchData: true,
          recognitionRecipients: toggledAssignee
            ? [filterAssigneeId]
            : participantIds,
        }}
      />
      <MeetingRecognitionCollapsible
        expandedUiPreferenceKey="meetingGivenRecognitionsExpanded"
        meeting={meeting}
        title={`${label("recognition", {
          pluralize: true,
          capitalize: true,
        })} given`}
        variables={{
          ...commonFilters,
          fetchData: true,
          createdByIds: toggledAssignee ? [filterAssigneeId] : participantIds,
        }}
      />
    </MeetingSidebarSection>
  );
};

const RecognitionsWithSentry = withErrorBoundary(Recognitions, {
  fallback: <Error description={"The recognitions could not be rendered."} />,
});

export default RecognitionsWithSentry;
